import { useState } from "react"

export const useFileImage = () => {
  const [fileImage, setFileImage] = useState<File | null>(null)

  return {
    fileImage,
    setFileImage,
  }
}
